import { z } from 'zod'
import type { Plan } from './schemas/plans'
import { LANGUAGES } from './schemas/simulation'
import type { ValidationCondition, ValidationStage } from './validation-stage'

/**
 * 홈·잠금화면 위젯과 시리용 요약 (2026-10-30 대표 지시, GET /widget/summary).
 * 앱이 열릴 때·백그라운드 갱신 때 받아 App Group(group.app.getrecipecat)에 그대로 저장하고, 위젯·App Intents 는 그 값만 읽는다.
 * 위젯은 번역하지 않으므로 글자 칸(…Label)은 서버가 요청 언어(lang)로 채운다. 코드 칸(stage·nextAction)은 위젯이 아이콘을 고를 때 쓴다.
 * 개인정보는 넣지 않는다 — 잠금화면에 보이는 값이다(제품 이름·단계·숫자만)
 */

/** GET /widget/summary?lang= */
export const widgetSummaryQuerySchema = z.object({ lang: z.enum(LANGUAGES).optional() })

export interface WidgetActiveProduct {
  /** 시뮬레이션 id — 위젯을 누르면 `/(create)/result?id=` 로 연다 */
  id: string
  /** 요청 언어의 제품 이름. 생성 중이라 아직 없으면 빈 글자 */
  name: string
  /** 생성 중(queued·running)이면 true. 그때 validationStage 는 null */
  generating: boolean
  /** 검증 단계 (@repo/shared judgeValidationStage). 생성 중이면 null */
  validationStage: ValidationStage | null
  validationStageLabel: string | null
  /** 다음 단계로 가려고 채울 첫 조건. 마지막 단계거나 생성 중이면 null */
  nextAction: ValidationCondition | null
  nextActionLabel: string | null
}

export interface WidgetSummary {
  /** 가장 최근에 손댄 제품 하나 (지운 제품·실패·취소 제외). 없으면 null */
  activeProduct: WidgetActiveProduct | null
  /** 공장 제안이 왔는데 아직 공장을 고르지 않은 견적 요청 수 */
  newQuotes: number
  /** 지금 더 만들 수 있는 생성 횟수 = 이번 기간 남은 횟수 + 산 팩 남은 횟수 */
  generationsLeft: number
  plan: Plan
  /** 이 요약을 만든 시각 (ISO). 위젯은 오래된 값이면 흐리게 그린다 */
  updatedAt: string
}
